import * as React from "react";
import { Provider } from "react-redux";
import { store } from "./store/store";
import { App } from "./App";
import { unregister } from "./registerServiceWorker";
import { I18nProvider } from "./components/app/I18nProvider";
import { i18nMessages } from "./configureI18n";
import { createRoot } from "react-dom/client";
import "./app.css";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Wrapper } from '@googlemaps/react-wrapper';
import { getApiKey } from "./utils/GoogleMapsUtils";

const queryClient = new QueryClient();

// Get the application-wide store instance, prepopulating with state from the server where available.
const container = document.getElementById("root");
const root = createRoot(container!);
root.render(
    <Provider store={store}>
        <QueryClientProvider client={queryClient}>
            <BrowserRouter>
                <I18nProvider messages={i18nMessages}>
                    <Wrapper apiKey={getApiKey()} libraries={['places']}>
                        <App />
                    </Wrapper>
                </I18nProvider>
            </BrowserRouter>
        </QueryClientProvider>
    </Provider>
);



// Registering the service worker causes issues with Hangfire
//registerServiceWorker();
unregister();
